document.addEventListener("DOMContentLoaded", () => {
    const date = document.querySelector("#date-timer-back-in-stock").value;
    const time = document.querySelector("#time-timer-back-in-stock").value;

    const timer = setInterval(() => {
        function getOffset() {
            return new Date()
                .toLocaleString("en-US", {
                    timeZone: "America/Chicago",
                    timeZoneName: "longOffset",
                })
                .replaceAll(":", "")
                .match(/([-\+][0-9]+)/)[1];
        }
        const currentDateTime = new Date();
        const endDateTime = new Date(`${date}T${time}${getOffset()}`);
        const endTimeDiff = endDateTime - currentDateTime;
        const containers = document.querySelectorAll("preorder-opener");
        // const days = Math.floor(
        //     (endTimeDiff % (1000 * 60 * 60 * 24 * 365)) / (1000 * 60 * 60 * 24)
        // );
        // const hours = Math.floor(
        //     (endTimeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        // );
        // const minutes = Math.floor(
        //     (endTimeDiff % (1000 * 60 * 60)) / (1000 * 60)
        // );
        // const seconds = Math.floor((endTimeDiff % (1000 * 60)) / 1000);
        // console.log("time", `${days}:${hours}:${minutes}:${seconds}`);
        containers.forEach((container) => {
            const parentContainer = container.parentNode;
            if (parentContainer.classList.contains("quickview-button")) {
                if (endTimeDiff <= 0) {
                    parentContainer.classList.remove(
                        "back-in-stock-container-btn"
                    );
                } else {
                    parentContainer.classList.add(
                        "back-in-stock-container-btn"
                    );
                }
            } else if (parentContainer.classList.contains("strict-hidden")) {
                if (endTimeDiff <= 0) {
                    parentContainer.classList.remove("strict-hidden");
                }
            } else {
                const btnSubmit = parentContainer.querySelector(
                    "input.btn.submit-btn"
                );
                if (btnSubmit) {
                    if (endTimeDiff <= 0) {
                        btnSubmit.classList.remove("strict-hidden");
                        btnSubmit.type = "submit";
                        btnSubmit.disabled = false;
                    } else {
                        btnSubmit.classList.add("strict-hidden");
                        btnSubmit.type = "hidden";
                        btnSubmit.disabled = true;
                    }
                }
            }
            if (container.classList.contains("over-functionality")) {
                if (endTimeDiff <= 0) {
                    container.classList.remove("strict-hidden");
                } else {
                    container.classList.add("strict-hidden");
                }
            } else {
                if (endTimeDiff <= 0) {
                    container.classList.add("strict-hidden");
                } else {
                    container.classList.remove("strict-hidden");
                }
            }
        });
        if (endTimeDiff <= 0) {
            clearInterval(timer);
        }
    }, 1000);
});
